import React from 'react';
import Icon from '../../../components/AppIcon';

const SubmissionGuidelines = () => {
  const guidelines = [
    {
      icon: 'FileText',
      title: 'ข้อมูลที่ต้องการ',
      description: 'กรอกข้อมูลให้ครบถ้วนและถูกต้อง เพื่อให้เจ้าหน้าที่สามารถติดต่อกลับได้'
    },
    {
      icon: 'Clock',
      title: 'ระยะเวลาดำเนินการ',
      description: 'เจ้าหน้าที่จะตรวจสอบและดำเนินการภายใน 7-15 วันทำการ'
    },
    {
      icon: 'Phone',
      title: 'การติดตาม',
      description: 'ท่านจะได้รับการแจ้งผลการดำเนินการทางโทรศัพท์หรืออีเมล'
    },
    {
      icon: 'Shield',
      title: 'ความเป็นส่วนตัว',
      description: 'ข้อมูลของท่านจะถูกเก็บรักษาเป็นความลับตามกฎหมาย'
    }
  ];

  const urgentContacts = [
    {
      type: 'โทรศัพท์',
      value: '02-123-4567',
      hours: 'จันทร์-ศุกร์ 08:30-16:30 น.',
      icon: 'Phone'
    },
    {
      type: 'อีเมล',
      value: 'districtthoeng@gmail.com',
      hours: 'ตอบกลับภายใน 24 ชั่วโมง',
      icon: 'Mail'
    },
    {
      type: 'เฉพาะกรณีฉุกเฉิน',
      value: '191 หรือ 1669',
      hours: 'ตลอด 24 ชั่วโมง',
      icon: 'AlertTriangle'
    }
  ];

  return (
    <div className="space-y-6">
      {/* Guidelines Section */}
      <div className="bg-card rounded-lg border border-border shadow-government p-6">
        <div className="flex items-center space-x-3 mb-4">
          <div className="w-8 h-8 bg-accent rounded-md flex items-center justify-center">
            <Icon name="Info" size={16} color="var(--color-accent-foreground)" />
          </div>
          <h3 className="text-lg font-semibold text-foreground">
            แนวทางการยื่นเรื่องร้องเรียน
          </h3>
        </div>

        <div className="space-y-4">
          {guidelines?.map((guideline, index) => (
            <div key={index} className="flex items-start space-x-3">
              <div className="w-8 h-8 bg-muted rounded-md flex items-center justify-center flex-shrink-0 mt-0.5">
                <Icon name={guideline?.icon} size={16} className="text-primary" />
              </div>
              <div className="flex-1">
                <h4 className="font-medium text-foreground text-sm">
                  {guideline?.title}
                </h4>
                <p className="text-sm text-muted-foreground mt-1 leading-relaxed">
                  {guideline?.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
      {/* Contact Information */}
      <div className="bg-card rounded-lg border border-border shadow-government p-6">
        <div className="flex items-center space-x-3 mb-4">
          <div className="w-8 h-8 bg-secondary rounded-md flex items-center justify-center">
            <Icon name="Headphones" size={16} color="white" />
          </div>
          <h3 className="text-lg font-semibold text-foreground">
            ช่องทางติดต่อ
          </h3>
        </div>

        <div className="space-y-4">
          {urgentContacts?.map((contact, index) => (
            <div key={index} className="flex items-start space-x-3 p-3 bg-muted/50 rounded-md">
              <div className="w-8 h-8 bg-background rounded-md flex items-center justify-center flex-shrink-0">
                <Icon name={contact?.icon} size={16} className="text-primary" />
              </div>
              <div className="flex-1">
                <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between">
                  <div>
                    <p className="font-medium text-foreground text-sm">
                      {contact?.type}
                    </p>
                    <p className="text-primary font-medium">
                      {contact?.value}
                    </p>
                  </div>
                  <p className="text-xs text-muted-foreground mt-1 sm:mt-0">
                    {contact?.hours}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      {/* Important Notice */}
      <div className="bg-warning/10 border border-warning/20 rounded-lg p-4">
        <div className="flex items-start space-x-3">
          <Icon name="AlertTriangle" size={20} className="text-warning flex-shrink-0 mt-0.5" />
          <div className="flex-1">
            <h4 className="font-medium text-warning-foreground text-sm mb-2">
              ข้อควรระวัง
            </h4>
            <ul className="text-sm text-muted-foreground space-y-1 list-disc list-inside">
              <li>กรุณาให้ข้อมูลที่เป็นจริงและตรวจสอบได้</li>
              <li>หลีกเลี่ยงการใช้ถ้อยคำที่ไม่เหมาะสมหรือหยาบคาย</li>
              <li>การยื่นเรื่องร้องเรียนเท็จอาจมีผลทางกฎหมาย</li>
              <li>สำหรับกรณีฉุกเฉินให้ติดต่อหมายเลข 191 หรือ 1669</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubmissionGuidelines;